export default "__VITE_PUBLIC_ASSET__ccd665d9__"